<template>
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M18.3337 8.33268V12.4993C18.3337 16.666 16.667 18.3327 12.5003 18.3327H7.50033C3.33366 18.3327 1.66699 16.666 1.66699 12.4993V7.49935C1.66699 3.33268 3.33366 1.66602 7.50033 1.66602H11.667" stroke="url(#paint0_linear_7317_14158)" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M18.3337 8.33268H15.0003C12.5003 8.33268 11.667 7.49935 11.667 4.99935V1.66602L18.3337 8.33268Z" stroke="url(#paint1_linear_7317_14158)" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M5.83301 10.834H10.833" stroke="url(#paint2_linear_7317_14158)" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M5.83301 14.166H9.16634" stroke="url(#paint3_linear_7317_14158)" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" />
    <defs>
      <linearGradient id="paint0_linear_7317_14158" x1="-0.985834" y1="-12.3386" x2="26.4823" y2="-7.36279" gradientUnits="userSpaceOnUse">
        <stop stop-color="#FECBD4" />
        <stop offset="0.345047" stop-color="#EB008B" stop-opacity="0.8" />
        <stop offset="0.857321" stop-color="#AA0085" stop-opacity="0.85" />
        <stop offset="1" stop-color="#8A008A" />
      </linearGradient>
      <linearGradient id="paint1_linear_7317_14158" x1="10.6059" y1="-3.93583" x2="21.5931" y2="-1.94551" gradientUnits="userSpaceOnUse">
        <stop stop-color="#FECBD4" />
        <stop offset="0.345047" stop-color="#EB008B" stop-opacity="0.8" />
        <stop offset="0.857321" stop-color="#AA0085" stop-opacity="0.85" />
        <stop offset="1" stop-color="#8A008A" />
      </linearGradient>
      <linearGradient id="paint2_linear_7317_14158" x1="5.03716" y1="9.99371" x2="9.71249" y2="14.2284" gradientUnits="userSpaceOnUse">
        <stop stop-color="#FECBD4" />
        <stop offset="0.345047" stop-color="#EB008B" stop-opacity="0.8" />
        <stop offset="0.857321" stop-color="#AA0085" stop-opacity="0.85" />
        <stop offset="1" stop-color="#8A008A" />
      </linearGradient>
      <linearGradient id="paint3_linear_7317_14158" x1="5.30244" y1="13.3257" x2="9.46033" y2="15.8364" gradientUnits="userSpaceOnUse">
        <stop stop-color="#FECBD4" />
        <stop offset="0.345047" stop-color="#EB008B" stop-opacity="0.8" />
        <stop offset="0.857321" stop-color="#AA0085" stop-opacity="0.85" />
        <stop offset="1" stop-color="#8A008A" />
      </linearGradient>
    </defs>
  </svg>
</template>
